<template>
  <!-- 发票明细列表 -->
  <div class="page">
    <div class="search">
      <!-- <el-button type="primary" @click="management">开票信息维护</el-button> -->
      <div class="title">发票明细</div>
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline"
        style="margin-top: 20px"
      >
        <el-form-item label="订单号：">
          <el-input
            style="width: 170px"
            v-model="formInline.orderNum"
            placeholder="订单号"
          ></el-input>
        </el-form-item>
        <el-form-item label="发票抬头：">
          <el-input
            style="width: 170px"
            v-model="formInline.companyName"
            placeholder="发票抬头"
          ></el-input>
        </el-form-item>
        <el-form-item label="申请开票日期：">
          <el-date-picker
            style="width: 170px"
            v-model="formInline.applyDate"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="开票日期：">
          <el-date-picker
            style="width: 170px"
            v-model="formInline.invoiceDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="发票状态">
          <el-select
            style="width: 170px"
            v-model="formInline.invoiceStatus"
            placeholder="请选择"
          >
            <el-option label="申请中" value="2"></el-option>
            <el-option label="已开票" value="3"></el-option>
            <el-option label="已邮寄" value="4"></el-option>
            <el-option label="开票失败" value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="query">查询</el-button>
          <el-button type="info" @click="Reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table">
      <el-table
        :data="tableData"
        border
        stripe
        style="width: 100%"
        :header-cell-style="{ background: '#F6F6FC', color: '#738DA2' }"
        :cell-style="{ color: '#738DA2' }"
        :height="tableHeight"
      >
        <el-table-column label="序号" align="center" type="index" width="50">
        </el-table-column>
        <el-table-column
          prop="applyDate"
          label="申请开票时间"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="warrantee"
          label="发票抬头"
          align="center"
          width="250"
        >
        </el-table-column>
        <el-table-column prop="orderFee" align="center" label="发票金额">
        </el-table-column>
        <el-table-column prop="invoiceType" align="center" label="发票类型">
          <template slot-scope="scope">
            <p v-show="scope.row.invoiceType == '0'">普票</p>
            <p v-show="scope.row.invoiceType == '1'">专票</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="invoiceTime"
          label="开票日期"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="invoiceStatus" align="center" label="发票状态">
          <template slot-scope="scope">
            <el-tag v-show="scope.row.invoiceStatus == '2'">申请中</el-tag>
            <el-tag type="warning" v-show="scope.row.invoiceStatus == '3'"
              >已开票</el-tag
            >
            <el-tag type="success" v-show="scope.row.invoiceStatus == '4'"
              >已邮寄</el-tag
            >
            <el-tag type="danger" v-show="scope.row.invoiceStatus == '5'">开票失败</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="withdrawal(scope.$index, scope.row)"
              >查看详情</el-button
            >
            <el-button
              size="mini"
              v-if="
                (scope.row.invoiceStatus == '3' || scope.row.invoiceStatus == '4')&&scope.row.invoiceType==0
              "
              type="primary"
              @click="download(scope.$index, scope.row)"
              >下载</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="this.formInline.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="this.formInline.pageNum"
        layout="total, sizes, prev, pager, next, jumper"
        :total="this.total"
      ></el-pagination>
    </div>
    <invoice-d
      :dialogVisible.sync="dialogVisible"
      :formData="formData"
    ></invoice-d>
  </div>
</template>

<script type="text/ecmascript-6">
import { getInvoiceList } from "../apis/project/index";
import InvoiceD from "./components/InvoiceD.vue";
export default {
  data() {
    return {
      current: 1,
      total: null,
      size: 1,
      tableHeight: null,
      formInline: {
        page: 1,
        pageNum: 10,
        userId: Number(window.sessionStorage.getItem("userId")),
        orderNum: "",
        companyName: "",
        applyDate: "",
        invoiceDate: "",
        invoiceStatus: "",
      },
      tableData: [],
      dialogVisible: false,
      formData: {},
    };
  },
  methods: {
    withdrawal(index, row) {
      this.dialogVisible = true;
      this.formData = row;
      // this.$router.push({ path: "/InvoiceD", query: row });
    },
    heightTab() {
      this.tableHeight = document.documentElement.clientHeight - 408;
    },
    Reset() {
      this.formInline = {
        page: 1,
        pageNum: 10,
        userId: Number(window.sessionStorage.getItem("userId")),
        orderNum: "",
        companyName: "",
        applyDate: "",
        invoiceDate: "",
        invoiceStatus: "",
      };
      this.getList();
    },
    download(index, row) {
      window.open(row.invoiceUrl, "_blank");
    },
    apply() {
      this.$router.push("/apply");
    },
    handleSizeChange(val) {
      this.formInline.pageNum = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.formInline.page = val;
      this.getList();
    },
    management() {
      this.$router.push("/management");
    },
    query(){
      this.formInline.page=1;
      this.getList();
    },
    getList() {
      getInvoiceList(this.formInline).then((res) => {
        this.tableData = res.data.data.data;
        this.total = res.data.data.total;
      });
    },
  },
  mounted() {
    this.heightTab();
    window.addEventListener("resize", this.heightTab, false);
    this.total = this.tableData.length;
    this.getList();
  },
  components: {
    InvoiceD,
  },
};
</script>

<style scoped>
.page{
  font-size: 16PX;
}
::v-deep .el-form-item__label {
  font-weight: bold;
}
</style>
